import { RouteComponentProps, Router } from "@reach/router"
import { FC } from "react"
import { PolicyLookup } from "../../integration/PolicyLookup"

export const PolicyLookupRouter: FC<RouteComponentProps> = () => (
  <Router>
    <PolicyLookup default />
  </Router>
)
